import { render, staticRenderFns } from "./CorporatePodcastEdit.vue?vue&type=template&id=4edaa4b0"
import script from "./CorporatePodcastEdit.vue?vue&type=script&lang=js"
export * from "./CorporatePodcastEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports